import React from "react";
import { Outlet } from "react-router-dom";

const WarehouseClient: React.FC = () => {
  return <Outlet />;
};

export default WarehouseClient;